import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

/**
 * Tells the server the parent has now been shown the outcome of their request,
 * so the banner appears on this visit and not on later ones.
 */
const AcknowledgeHouseholdChangeRequestMutation = graphql.persisted(
  "AcknowledgeHouseholdChangeRequest",
  graphql(`
    mutation AcknowledgeHouseholdChangeRequest($requestId: ID!) {
      acknowledgeHouseholdChangeRequest(input: { requestId: $requestId }) {
        changeRequest { id }
        userErrors { message path }
      }
    }
  `)
);

export { AcknowledgeHouseholdChangeRequestMutation };

export function useAcknowledgeHouseholdChangeRequest() {
  return useMutation(AcknowledgeHouseholdChangeRequestMutation);
}
